<template>
  <Card class="layout-card" style="height: 100%">
    <div class="advertise-toolbar">
      <div class="advertise-search-row">
        <div class="crowd-filter-group">
          <RadioGroup
            v-model="searchForm.crowdType"
            type="button"
            button-style="solid"
            @on-change="handleCrowdTypeChange"
          >
            <Radio :label="-1">不限</Radio>
            <Radio :label="0">选择人群包</Radio>
          </RadioGroup>
          <Select
            v-model="searchForm.crowdIds"
            placeholder="请选择人群包"
            style="width: 150px"
            clearable
            filterable
            :disabled="searchForm.crowdType !== 0"
          >
            <Option v-for="item in crowdList" :key="item.id" :value="item.id" :label="item.name ? item.name.trim() : ''">
              {{ item.name ? item.name.trim() : '' }}
            </Option>
          </Select>
        </div>
        <div>
          <Select
            v-model="searchForm.signInAdEnabled"
            placeholder="签到位广告开启状态"
            style="width: 150px"
            clearable
          >
            <Option value="true">开启</Option>
            <Option value="false">关闭</Option>
          </Select>
        </div>
        <div>
          <Select
            v-model="searchForm.episodeUnlockAdEnabled"
            placeholder="剧集解锁广告开启状态"
            style="width: 150px"
            clearable
          >
            <Option value="true">开启</Option>
            <Option value="false">关闭</Option>
          </Select>
        </div>
        <div>
          <Select
            v-model="searchForm.splashAdEnabled"
            placeholder="开屏广告开启状态"
            style="width: 150px"
            clearable
          >
            <Option value="true">开启</Option>
            <Option value="false">关闭</Option>
          </Select>
        </div>
        <div>
          <Select
            v-model="searchForm.feedAdEnabled"
            placeholder="信息流广告开启状态"
            style="width: 150px"
            clearable
          >
            <Option value="true">开启</Option>
            <Option value="false">关闭</Option>
          </Select>
        </div>
        <div>
          <Select
            v-model="searchForm.interstitialAdEnabled"
            placeholder="插屏广告开启状态"
            style="width: 150px"
            clearable
          >
            <Option value="true">开启</Option>
            <Option value="false">关闭</Option>
          </Select>
        </div>
        <div>
          <Input
            v-model="searchForm.name"
            placeholder="请输入广告策略名称搜索"
            style="width: 150px"
          />
        </div>
        <div class="advertise-search-button">
          <Button type="primary" @click="getData()">搜索</Button>
        </div>
        <Button
          type="success"
          class="advertise-add-button"
          @click="handleOpenEditModal()"
        >
          新增广告策略
        </Button>
      </div>
    </div>

    <div class="advertise-table-wrap">
      <Table :data="tableData" :columns="columns" :loading="tableLoading">
        <template slot="action" slot-scope="{ row }">
          <a @click="handleView(row)">查看</a>
          <a @click="handleOpenEditModal(row)" style="margin-left: 20px">
            编辑
          </a>
          <a @click="handleDel(row)" style="margin-left: 20px"> 删除 </a>
        </template>
        <template slot="tag1" slot-scope="{ row }">
          <Tag v-if="row.signInAdEnabled" color="green" style="cursor: default">
            开启
          </Tag>
          <Tag v-else color="red" style="cursor: default">关闭</Tag>
        </template>
        <template slot="tag2" slot-scope="{ row }">
          <Tag
            v-if="row.episodeUnlockAdEnabled"
            color="green"
            style="cursor: default"
          >
            开启
          </Tag>
          <Tag v-else color="red" style="cursor: default">关闭</Tag>
        </template>
        <template slot="tag3" slot-scope="{ row }">
          <Tag v-if="row.splashAdEnabled" color="green" style="cursor: default">
            开启
          </Tag>
          <Tag v-else color="red" style="cursor: default">关闭</Tag>
        </template>
        <template slot="tag4" slot-scope="{ row }">
          <Tag v-if="row.feedAdEnabled" color="green" style="cursor: default">
            开启
          </Tag>
          <Tag v-else color="red" style="cursor: default">关闭</Tag>
        </template>
        <template slot="tag5" slot-scope="{ row }">
          <Tag v-if="row.interstitialAdEnabled" color="green" style="cursor: default">
            开启
          </Tag>
          <Tag v-else color="red" style="cursor: default">关闭</Tag>
        </template>
        <Pages slot="footer" :page="page" :func="getData"></Pages>
      </Table>
    </div>

    <EditModal
      v-model="editVisible"
      :data="form"
      :readonly="editReadonly"
      :crowd-options="crowdList"
      @on-success="handleSaveSuccess"
    />
  </Card>
</template>

<script>
import Pages from '@/components/pages'
import EditModal from './components/EditModal.vue'
import { advertisePage, getAdStrategyInfo, delAd } from '@/api/advertise'
import { getCrowdList } from '@/api/crowd'

const createDefaultSearchForm = () => ({
  crowdType: undefined,
  crowdIds: '',
  signInAdEnabled: '',
  episodeUnlockAdEnabled: '',
  splashAdEnabled: '',
  feedAdEnabled: '',
  interstitialAdEnabled: '',
  name: ''
})

const buildCrowdNamesText = (crowdNames) => {
  if (typeof crowdNames === 'string' && crowdNames) return crowdNames
  if (!Array.isArray(crowdNames) || !crowdNames.length) return '-'
  return crowdNames.join(',')
}

export default {
  name: 'AdvertiseSettingList',
  components: {
    Pages,
    EditModal
  },
  data() {
    return {
      editVisible: false,
      editReadonly: false,
      tableLoading: false,
      form: {},
      searchForm: createDefaultSearchForm(),
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      tableData: [],
      crowdList: [],
      columns: [
        {
          title: '名称',
          key: 'name'
        },
        {
          title: '人群包',
          key: 'crowdNames',
          tooltip: true,
          tooltipMaxWidth: 200,
          width: 150,
          render: (h, params) => {
            const text = buildCrowdNamesText(params.row.crowdNames)
            return <Tooltip content={text} maxWidth={200} transfer style="width:100%">
              <div style={{
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                width: '100%',
                overflow: 'hidden'
              }}>{text}</div>
            </Tooltip>
          }
        },
        {
          title: '签到位广告',
          key: 'signInAdEnabled',
          slot: 'tag1'
        },
        {
          title: '剧集解锁广告',
          key: 'episodeUnlockAdEnabled',
          slot: 'tag2'
        },
        {
          title: '开屏广告',
          key: 'splashAdEnabled',
          slot: 'tag3'
        },
        {
          title: '信息流广告',
          key: 'feedAdEnabled',
          slot: 'tag4'
        },
        {
          title: '插屏广告',
          key: 'interstitialAdEnabled',
          slot: 'tag5'
        },
        {
          title: '更新人',
          key: 'updateUserName'
        },
        {
          title: '操作',
          align: 'center',
          slot: 'action'
        }
      ]
    }
  },
  methods: {
    parseBooleanFilter(value) {
      if (value === 'true') return true
      if (value === 'false') return false
      return undefined
    },
    buildSearchPayload() {
      const payload = {
        current: this.page.current,
        size: this.page.size,
        name: this.searchForm.name || undefined,
        signInAdEnabled: this.parseBooleanFilter(
          this.searchForm.signInAdEnabled
        ),
        episodeUnlockAdEnabled: this.parseBooleanFilter(
          this.searchForm.episodeUnlockAdEnabled
        ),
        splashAdEnabled: this.parseBooleanFilter(
          this.searchForm.splashAdEnabled
        ),
        feedAdEnabled: this.parseBooleanFilter(this.searchForm.feedAdEnabled),
        interstitialAdEnabled: this.parseBooleanFilter(
          this.searchForm.interstitialAdEnabled
        )
      }

      if (this.searchForm.crowdIds || this.searchForm.crowdIds === 0) {
        payload.crowdIds = [this.searchForm.crowdIds]
      }
      if (this.searchForm.crowdType === 0 || this.searchForm.crowdType === -1) {
        payload.crowdType = this.searchForm.crowdType
      }

      return payload
    },
    handleCrowdTypeChange(value) {
      if (value !== 0) {
        this.searchForm.crowdIds = ''
      }
    },
    async getData(page) {
      if (page) this.page.current = page
      else this.page.current = 1

      this.tableLoading = true
      try {
        const { data } = await advertisePage(this.buildSearchPayload())
        this.tableData = data.records || []
        this.page.current = data.current || this.page.current
        this.page.total = data.total || 0
      } catch (error) {
        this.$Message.error('获取列表失败')
      } finally {
        this.tableLoading = false
      }
    },
    async handelCrowdList() {
      try {
        const { data } = await getCrowdList({
          current: -1,
          size: -1,
          total: -1
        })
        this.crowdList = data.records || []
      } catch (error) {
        this.$Message.error('获取人群包列表失败')
      }
    },
    async openModalWithDetail(row, readonly) {
      this.editReadonly = readonly

      if (!row || !row.id) {
        this.form = {}
        this.editVisible = true
        return
      }

      this.tableLoading = true
      try {
        const { data } = await getAdStrategyInfo(row.id)
        this.form = data || {}
        this.editVisible = true
      } catch (error) {
        this.$Message.error('获取详情失败')
      } finally {
        this.tableLoading = false
      }
    },
    handleDel(row) {
      delAd(row.id).then(() => {
        this.getData(this.page.current)
      })
    },
    handleOpenEditModal(row) {
      this.openModalWithDetail(row, false)
    },
    handleView(row) {
      this.openModalWithDetail(row, true)
    },
    handleReset() {
      this.searchForm = createDefaultSearchForm()
      this.getData()
    },
    handleSaveSuccess() {
      this.getData(this.page.current)
    }
  },
  mounted() {
    this.getData()
    this.handelCrowdList()
  }
}
</script>

<style scoped lang="less">
.advertise-toolbar {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  flex-shrink: 0;
}

.advertise-search-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
  & > * {
    flex-shrink: 0;
  }
}

.crowd-filter-group {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.advertise-search-button {
  margin-left: 0;
}

.advertise-add-button {
  margin-left: 0;
  flex-shrink: 0;
}

.advertise-table-wrap {
  flex: 1;
  min-height: 0;
  overflow: auto;
}

.layout-card {
  /deep/ .ivu-card-body {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
}
</style>
